// The tenant bearer token is held in module memory only. localStorage,
// sessionStorage, cookies and IndexedDB are never touched: a page refresh
// clears the session and the user signs in again. This module has no import
// relationship with the platform panel's own session store.

let currentToken: string | null = null;

export function readTenantToken(): string | null {
  return currentToken;
}

export function writeTenantToken(token: string): void {
  const trimmed = token.trim();
  currentToken = trimmed.length > 0 ? trimmed : null;
}

export function clearTenantToken(): void {
  currentToken = null;
}
